<template>
    <div class="container" v-if="product"  style='position: relative'>
      <snackbar class="tag-partner"/>
      <product-content class="ma-auto pa-5 pt-5" :item="product" :action="false" style='max-width: 1200px'/>
      <checkout-footer :recipesFooter="false"/>
    </div>

</template>

<script>
import { ExtraApi } from '../../api/ExtraApi'
import { Product } from '../../core/Product'
import ProductContent from './ProductContent'
import Snackbar from '../Elements/Snackbar'
import CheckoutFooter from '../Checkout/CheckoutFooter'

export default {
  components: {
    ProductContent,
    Snackbar,
    CheckoutFooter
  },
  watch: {
      '$route.params.id': {
          handler() {
              this.load()
          }
      }
  },

  data () {
    return {
      loading: true,
      productId: null,
      product: null
    }
  },
  methods: {
    load() {
      this.productId = this.$route.params.id

      var rm = new ExtraApi()
      rm.all({params: {query: 'id eq '+this.productId, 'productables': true}}).then(response => {
        this.product = Product.createFromExtra(response.body.data.resources[0])
        this.loading = false
      }).catch(() => {
        this.$router.push({ name: 'flow-subscribed' })
      })
    }
  },
  mounted () {
    this.load()
  }
}

</script>